// extracted by mini-css-extract-plugin
module.exports = {"component":"Header_component__2Kka9"};